// extracted by mini-css-extract-plugin
export default {"BreakpointFromLarge":"(min-width: 960px)","wrapper":"TwoColumns_wrapper__nwdKK","spacing":"TwoColumns_spacing__ZPCaS"};